import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Maine = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Maine Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Lead Paint Disclosure: Required for homes built before 1978.
        </Text>

        <Text style={styles.listItem}>
          2. Private Sewage Disposal System Disclosure: Mandatory for applicable
          properties.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – Sellers are required to disclose information regarding the
          property's water supply, insulation, heating, waste disposal, and any
          defects.
        </Text>
      </View>
    </View>
  );
};

export default Maine;
